import { Injectable } from '@angular/core';
import { DataService } from 'src/app/data.service';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
@Injectable()
export class ToolService {
  public calcs: any = null;
  public _spinner = new BehaviorSubject(false);
  public spinner$: Observable<boolean> = this._spinner.asObservable();

  constructor(public dataService: DataService) {}

  public readData(calcName: string): Observable<any> {
    //TODO Jak api będzie gotowe to get
    // const form = localStorage.getItem(`form${formNumber}`);
    if (this.calcs) {
      // if (this.calcs)
      if (this.calcs.find((calc) => calc.name === calcName)) {
        return this.dataService.invoke(
          `/salonexpert-business/client-calculator/${
            this.calcs.find((calc) => calc.name === calcName).id
          }`,
          'get'
        );
      } else {
        return of(null);
      }
    } else {
      return this.dataService
        .invoke(`/salonexpert-business/client-calculators`, 'get')
        .pipe(
          switchMap((res: any) => {
            this.calcs = res;
            // if (this.calcs)
            if (this.calcs.find((calc) => calc.name === calcName)) {
              return this.dataService.invoke(
                `/salonexpert-business/client-calculator/${
                  this.calcs.find((calc) => calc.name === calcName).id
                }`,
                'get'
              );
            } else {
              return of(null);
            }
          })
        );
    }
    // return form ? JSON.parse(form) : {};
  }

  public saveData(calcName: string, data: any): Observable<any> {
    //TODO Jak api będzie gotowe to post
    // if (this.calcs)
    if (!this.calcs || !this.calcs.find((calc) => calc.name === calcName)) {
      return this.dataService.invoke(
        `/salonexpert-business/client-calculator`,
        'post',
        null,
        {
          name: calcName,
          content: JSON.stringify(data),
        }
      );
    } else {
      return this.dataService.invoke(
        `/salonexpert-business/client-calculator/${
          this.calcs.find((calc) => calc.name === calcName).id
        }`,
        'put',
        null,
        {
          name: calcName,
          content: JSON.stringify(data),
        }
      );
    }
  }

  public checkQuizAnswers(quizForm: any): any {
    const results = {
      1: {},
      2: {},
      3: {},
      4: {},
      5: {},
      6: {},
      7: {},
      8: {},
      9: {},
      10: {},
    };
    //first question
    const firstA = String(quizForm['1']['1']).toLowerCase();
    const firstB = String(quizForm['1']['2']).toLowerCase();
    const firstC = String(quizForm['1']['3']).toLowerCase();
    const firstD = String(quizForm['1']['4']).toLowerCase();

    const answersFirst = [
      'strój i wygląd',
      'postawa',
      'umiejętności sprzedażowe',
      'wiedza produktowa',
    ];

    if (firstA.indexOf(answersFirst[0]) > -1) {
      results['1']['1'] = true;
    } else if (firstB.indexOf(answersFirst[0]) > -1) {
      results['1']['2'] = true;
    } else if (firstC.indexOf(answersFirst[0]) > -1) {
      results['1']['3'] = true;
    } else if (firstD.indexOf(answersFirst[0]) > -1) {
      results['1']['4'] = true;
    }

    if (firstA.indexOf(answersFirst[1]) > -1) {
      results['1']['1'] = true;
    } else if (firstB.indexOf(answersFirst[1]) > -1) {
      results['1']['2'] = true;
    } else if (firstC.indexOf(answersFirst[1]) > -1) {
      results['1']['3'] = true;
    } else if (firstD.indexOf(answersFirst[1]) > -1) {
      results['1']['4'] = true;
    }

    if (firstA.indexOf(answersFirst[2]) > -1) {
      results['1']['1'] = true;
    } else if (firstB.indexOf(answersFirst[2]) > -1) {
      results['1']['2'] = true;
    } else if (firstC.indexOf(answersFirst[2]) > -1) {
      results['1']['3'] = true;
    } else if (firstD.indexOf(answersFirst[2]) > -1) {
      results['1']['4'] = true;
    }

    if (firstA.indexOf(answersFirst[3]) > -1) {
      results['1']['1'] = true;
    } else if (firstB.indexOf(answersFirst[3]) > -1) {
      results['1']['2'] = true;
    } else if (firstC.indexOf(answersFirst[3]) > -1) {
      results['1']['3'] = true;
    } else if (firstD.indexOf(answersFirst[3]) > -1) {
      results['1']['4'] = true;
    }

    for (let i = 1; i < 5; i++) {
      results['1'][String(i)]
        ? (results['1'][String(i)] = true)
        : (results['1'][String(i)] = false);
    }

    //FIRST QUESTSION ENDED
    //SECOND QUESTION

    if (String(quizForm['2']).toUpperCase() === 'A') {
      results['2'] = true;
    } else {
      results['2'] = false;
    }

    //SECOND QUESTSION ENDED
    //THIRD QUESTION

    if (String(quizForm['3']).toUpperCase() === 'C') {
      results['3'] = true;
    } else {
      results['3'] = false;
    }

    //THIRD QUESTSION ENDED
    //FOURTH QUESTION

    if (String(quizForm['4']).toUpperCase() === 'B') {
      results['4'] = true;
    } else {
      results['4'] = false;
    }

    //FOURTH QUESTSION ENDED
    //FIFTH QUESTION

    if (String(quizForm['5']).toUpperCase() === 'B') {
      results['5'] = true;
    } else {
      results['5'] = false;
    }

    //FIFTH QUESTSION ENDED
    //SIXTH QUESTION

    if (String(quizForm['6']).toUpperCase() === 'A') {
      results['6'] = true;
    } else {
      results['6'] = false;
    }

    //SIXTH QUESTSION ENDED
    //SEVENTH QUESTION

    if (quizForm['7']['1']) {
      results['7']['1'] = true;
    } else {
      results['7']['1'] = false;
    }

    if (quizForm['7']['2']) {
      results['7']['2'] = true;
    } else {
      results['7']['2'] = false;
    }

    if (quizForm['7']['3']) {
      results['7']['3'] = true;
    } else {
      results['7']['3'] = false;
    }

    //EIGHTH QUESTSION ENDED
    //NINTH QUESTION
    results['8']['1'] = String(quizForm['8']['1']);
    results['8']['2'] = String(quizForm['8']['2']);

    //EIGHTH QUESTSION ENDED
    //NINTH QUESTION

    if (String(quizForm['9']).toUpperCase() === 'A') {
      results['9'] = true;
    } else {
      results['9'] = false;
    }

    //NINTH QUESTSION ENDED
    //TENTH QUESTION
    results['10']['1'] = String(quizForm['10']['1']);
    results['10']['2'] = String(quizForm['10']['2']);
    results['10']['3'] = String(quizForm['10']['3']);
    results['10']['4'] = String(quizForm['10']['4']);
    results['10']['5'] = String(quizForm['10']['5']);

    return results;
  }
}
